(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@antv/g2plot"), require("vue"), require("vuex"));
	else if(typeof define === 'function' && define.amd)
		define(["@antv/g2plot", "vue", "vuex"], factory);
	else if(typeof exports === 'object')
		exports["CDSPBiDashboard"] = factory(require("@antv/g2plot"), require("vue"), require("vuex"));
	else
		root["CDSPBiDashboard"] = factory(root["G2Plot"], root["Vue"], root["Vuex"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__5740__, __WEBPACK_EXTERNAL_MODULE__5594__, __WEBPACK_EXTERNAL_MODULE__8714__) => {
return 